import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//for pagination kauhsalya(2017-08-03)
import {NgxPaginationModule} from 'ngx-pagination';
import { TagInputModule } from 'ng2-tag-input';
import { MyDatePickerModule } from 'mydatepicker';
// import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { TooltipModule } from 'ng2-tooltip';
import {TranslateModule} from 'ng2-translate';
import {SelectModule} from 'angular2-select';

import { IssueMainComponent } from './components/issue-main.component';
import { AllIssueComponent } from './components/all-issue.component';

import { IssueCreaterModule } from './shared/issue-creater/issue-creater.module';
import { ModalTaskModule } from '../work/modal/modal-task/modal-task.module';
import { ConfirmationModule } from '../../shared/modules/confirmation/confirmation.module';

import { mainRouting } from '../main.routes';

@NgModule({
  declarations: [
    IssueMainComponent,
    AllIssueComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    
    TranslateModule,
    MyDatePickerModule,
    // MultiselectDropdownModule,
    TagInputModule,
    TooltipModule,
    SelectModule,

    IssueCreaterModule,
    ModalTaskModule,
    ConfirmationModule,
    
    mainRouting,
    NgxPaginationModule
  ]
})
export class IssuesModule { }



// WEBPACK FOOTER //
// ./src/app/modules/issues/issues.module.ts